import React, { Component } from 'react';

import classes from './NewResource.css';
import NewRequestSequential from '../../components/UI/NewRequestSequential/NewRequestSequential';
import Aux from '../../hoc/Auxiliary/Auxiliary';

class NewResource extends Component {

  state = {
    show: true
  }

  render() {

    return (
      <Aux>
        <NewRequestSequential
          fullScreen
          show={this.state.show}
          closeCard={(ev) => this.setState({ show: false })} />
      </Aux>
    );
  }
}

export default NewResource;



// WEBPACK FOOTER //
// ./src/containers/NewResource/NewResource.js